export const RightSlideAbsoluteAnimation = {
  initial: { y: "100%" },
  animate: { y: "0%" },
  exit: { y: "100%" },
  transition: { type: "spring", stiffness: 300, damping: 30 },
  style: { position: "absolute", top: 0, left: 0, width: "100%", height: "93vh", zIndex: "5" }
};

export const FadeInOpacityAbsoluteAnimation = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.35 },
  style: { position: "absolute", top: 0, left: 0, width: "100%", height: "93vh", zIndex: "5" }
};

export const FadeInOpacityAnimation = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.35 }
};

export const FadeInAnimation_Opacity_FromRight = {
  initial: { opacity: 0, x: -20 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: 20 },
  transition: { duration: 0.25 }
};
